import './styles/main.scss';

/**
 * Page: Dark Template
 */

if ( document.body.classList.contains('page-template-wp-custom-template-page-dark') ) {
	const onScroll = () => {
		const hasScrolled = ( document.documentElement.scrollTop > Math.min( window.innerHeight, 640 ) );
		document.body.classList.toggle( 'has-scrolled', hasScrolled );
	};

	window.addEventListener( 'orientationchange', onScroll );
	window.addEventListener( 'scroll', onScroll );
}
